import React, { useEffect, useRef, useState } from "react";
import { IoIosAddCircleOutline } from "react-icons/io";
import * as Yup from "yup";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { base_url } from "../../../utils/AxiosConfig";
import axios from "axios";
import dayjs from 'dayjs';


let LeaveApplicationschema = Yup.object().shape({
  CmpCode: Yup.string(),

  EmpID: Yup.string(),
  Leave_Category: Yup.string(),
  ApplicationDAte: Yup.string(),
  FromDate: Yup.string(),
  ToDate: Yup.string(),
  NoOfDays: Yup.string(),
  Notes: Yup.string(),
  ApprovalSatus: Yup.string(),
  ApprovalBy: Yup.string(),
  ApprovalDate: Yup.string(),
  RejoinDate: Yup.string(),
  RejoinComments: Yup.string(),
  Ticket: Yup.string(),
  Approvalnote: Yup.string(),
  Designation: Yup.string(),
  CDL_Address: Yup.string(),
  CDL_Street: Yup.string(),
  CDL_City: Yup.string(),
  CDL_State: Yup.string(),
  CDL_Zip: Yup.string(),
  CDL_Phone: Yup.string(),
  CDL_Email: Yup.string(),
});

const LeaveApplicationPopup = ({ empPopup }) => {
  console.log("empPopup:", empPopup);

  const storedUserDataArray =
    JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  let companyCode = null;

  if (storedUserDataArray) {
    companyCode = storedUserDataArray[0].cmpcode;
  }

  const [Data, setData] = useState();
  const fromDate = useRef();
  const toDate = useRef();
  const [Today, setToday] = useState();
  const [Value, setValue] = useState();
  const [FromDate, setFromDate] = useState();
  const [ToDate, setToDate] = useState();
  const [DiffDays, setDiffDays] = useState("1");
  const [LeaveData, setLeaveData] = useState();
  const [LeaveHistoryData, setLeaveHistoryData] = useState();
  const [OtherLeaveHistoryData, setOtherLeaveHistoryData] = useState();
  const [availableDaysCount, setAvailableDaysCount] = useState([]);

  console.log("empPopup", empPopup);
  console.log("OtherLeaveHistoryData:", OtherLeaveHistoryData);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      CmpCode: companyCode,
      EmpID: empPopup.EmpId ? empPopup.EmpId : "",
      Leave_Category: "",
      // name: empPopup.Name?empPopup.Name :"",
      ApplicationDAte: Today,
      FromDate: FromDate || "",
      ToDate: ToDate || "",
      NoOfDays: DiffDays || "1",
      Notes: "",
      ApprovalSatus: "-",
      ApprovalBy: "HR Manager",
      ApprovalDate: "-",
      RejoinDate: "-",
      RejoinComments: "-",
      Ticket: "-",
      Approvalnote: "-",
      Designation: empPopup.JobTitle ? empPopup.JobTitle : "-",
      CDL_Address: "-",
      CDL_Street: "-",
      CDL_City: "-",
      CDL_State: "-",
      CDL_Zip: "-",
      CDL_Phone: "-",
      CDL_Email: "-",
    },
    validationSchema: LeaveApplicationschema,
    onSubmit: (values) => {
      console.log(values);
      setValue([values]);
    },
  });

  useEffect(() => {
    const LeaveHistory = async () => {
      try {
        const response = await axios.get(
          `${base_url}/api/PersonalInfoLeaveStatusList/${companyCode}/LEAVEHISTORY/${
          empPopup?.EmpId
          }/1900-01-01/1900-01-01/-`
          // }/${FromDate}/${ToDate}/-`
        );
        if (response?.data) {
          setLeaveHistoryData(response.data);
        } else {
          console.log("error");
        }
      } catch (err) {
        console.error("Error while fetchinh leave history:", err);
      }
    };

    const OtherLeaveHistory = async () => {
      try {
        const response = await axios.get(
          `${base_url}/api/PersonalInfoLeaveStatusList/${companyCode}/LEAVEHISTORYOTHER/${
            empPopup?.EmpId ? empPopup?.EmpId : null
          }/${FromDate}/${ToDate}/-`
        );
        if (response?.data) {
           console.log('otherLeaveeHistory',response.data)
          setOtherLeaveHistoryData(response.data);
        } else {
          console.log("error");
        }
      } catch (err) {
        console.error("Error while fetchinh leave history:", err);
      }
    };

    if (empPopup?.EmpId) {
      LeaveHistory();
      // OtherLeaveHistory();
    }

    if (empPopup?.EmpId && FromDate && ToDate) {
      // LeaveHistory();
      OtherLeaveHistory();
    }
  }, [empPopup?.EmpId, FromDate, ToDate]);


  
  

  
  useEffect(() => {
    const today = new Date();
    const formattedDate = today.toISOString().split("T")[0];
    setToday(formattedDate);
    LeaveHistory();
    // OtherLeaveHistory();
  }, []);

    const LeaveHistory = async () => {
      try {
        const response = await axios.get(
          `${base_url}/api/PersonalInfoLeaveStatusList/${companyCode}/LEAVEHISTORY/${
            empPopup?.EmpId ? empPopup?.EmpId : null
          }/1900-01-01/1900-01-01/-`
          // }/${FromDate}/${ToDate}/-`
        );
        if (response?.data) {
          setLeaveHistoryData(response.data);
        } else {
          console.log("error");
        }
      } catch (err) {
        console.error("Error while fetchinh leave history:", err);
      }
    };

  // const OtherLeaveHistory = async () => {
  //   try {
  //     const response = await axios.get(
  //       `${base_url}/api/PersonalInfoLeaveStatusList/${companyCode}/LEAVEHISTORYOTHER/${
  //         empPopup?.EmpId ? empPopup?.EmpId : null
  //       }/${FromDate}/${ToDate}/-`
  //     );
  //     // api/PersonalInfoLeaveStatusList/CUBIX/LEAVEHISTORYOTHER/CBM001/2025-01-01/2025-12-01/-
  //     if (response?.data) {
       
  //       setOtherLeaveHistoryData(response.data[0]);
  //     } else {
  //       console.log("error");
  //     }
  //   } catch (err) {
  //     console.error("Error while fetchinh other leave history:", err);
  //   }
  // };


  useEffect(() => {
    console.log("empPopup:", empPopup);
  }, [empPopup]);

  useEffect(() => {
    const startDateObj = new Date(FromDate);
    const endDateObj = new Date(ToDate);

    var Difference_In_Time = startDateObj - endDateObj;
    let Difference_In_Days = Math.floor(
      Difference_In_Time / (1000 * 60 * 60 * 24)
    );
    let difday = Math.abs(Difference_In_Days) + 1;
    setDiffDays(difday);
    console.log(difday);
  }, [FromDate, ToDate]);

  useEffect(() => {
    const getData = async () => {
      const response = await axios.post(
        `${base_url}/api/PersonalInfoLeaveApplicationReg`,
        Value
      );
      if (response?.data) {
        setData(response.data);
        toast.success("Leave Application Send Successfully");
      } else {
        toast.error("Something Went Wrong");
      }
    };
    if (Value) {
      getData();
    }
  }, [Value]);

  useEffect(() => {
     const employeeID = empPopup?.EmpId;
    const getLeave = async () => {
      try {

        console.log(`base_url:,${base_url}/api/CpaysCount/${companyCode}/LEAVECATEGORY/${employeeID}/-`)
        const response = await axios.get(
          // `${base_url}/api/PersonalInfoLeaveCategoryList/${companyCode}/ALL/-`
          `${base_url}/api/CpaysCount/${companyCode}/LEAVECATEGORY/${empPopup?.EmpId}/-`
        );
        if (response?.data) {
          console.log("leave category:", response.data[0].leavecateGory);
          setLeaveData(response.data);
       
        } else {
          console.log("error");
        }
      } catch (error) {
        console.error("PersonalInfoLeaveCategoryListEerror:", error);
      }
    };

    getLeave();
  }, [empPopup?.EmpId]);

  

  const getAvailableDays = async (empID) => {
    
const selectedLeave = formik.values.Leave_Category ? formik.values.Leave_Category : 'null';
console.log('selected Leave',selectedLeave)
const encodedLeave = encodeURIComponent(selectedLeave);
console.log('encoded Leave',encodedLeave)

let apiURL = `${base_url}/api/CpaysCount/${companyCode}/AVAIL_LEAVES/${empID}/${encodedLeave}`;

// `${base_url}/api/CpaysCount/${companyCode}/AVAIL_LEAVES/${empID}/${selectedLeave}?${selectedLeave}:null`
    try {
      const response = await axios.get(apiURL);
      if (response?.data) {
        console.log("Available Days:", response.data);
        setAvailableDaysCount(response.data[0]?.Balance);
      } else {
        console.log("error");
      }
    } catch (error) {
      console.error("AvailableDaysListEerror:", error);
    }
  };

  const employeeID = empPopup?.EmpId;
  // const employeeID = empPopup;
  console.log("employeeID:", employeeID);
  // useEffect(() => {
  //   getAvailableDays(employeeID);
  // }, [employeeID, companyCode]);
  useEffect(() => {
    getAvailableDays(employeeID);
  }, [formik.values.Leave_Category ]);

  return (
    <div>
      <div
        class="modal fade"
        id="exampleModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">
                Leave Application
              </h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              <form action="" onSubmit={formik.handleSubmit}>
                <div className="add-form">
                  <div className="scroll h-auto">
                    <table class="table">
                      <tbody>
                        <tr>
                          <td>Date of Request</td>
                          <td>
                            <input
                              type="text"
                              placeholder="Request Date"
                              className="form-control small-box"
                              onChange={formik.handleChange("ApplicationDAte")}
                              onBlur={formik.handleBlur("ApplicationDAte")}
                              value={formik.values.ApplicationDAte}
                              disabled
                            />
                          </td>
                          <td>Emp Id</td>
                          <td>
                            <input
                              type="text"
                              placeholder="Emp Id"
                              className="form-control small-box"
                              onChange={formik.handleChange("EmpID")}
                              onBlur={formik.handleBlur("EmpID")}
                              value={formik.values.EmpID}
                              disabled
                            />
                          </td>
                        </tr>

                        <tr>
                          <td>Emp Name</td>
                          <td>
                            <input
                              type="text"
                              placeholder="Emp Name"
                              className="form-control small-box"
                              onChange={formik.handleChange("name")}
                              onBlur={formik.handleBlur("name")}
                              value={empPopup.Name ? empPopup.Name : "-"}
                              disabled
                            />
                          </td>
                          <td>Designation</td>
                          <td>
                            <input
                              type="text"
                              placeholder="Designation"
                              className="form-control small-box"
                              onChange={formik.handleChange("Designation")}
                              onBlur={formik.handleBlur("Designation")}
                              value={formik.values.Designation}
                              disabled
                            />
                          </td>
                        </tr>
                        <tr>
                          {/* <td>Leave From</td>
                          <td>
                            <input
                              type="text"
                              placeholder="Leave From"
                              ref={fromDate}
                              onFocus={() => (fromDate.current.type = "date")}
                              onBlur={() => (fromDate.current.type = "date")}
                              className="form-control small-box"
                              onChange={(e) => setFromDate(e.target.value)}
                            />
                          </td>
                          <td>Leave To</td>
                          <td>
                            <input
                              type="text"
                              placeholder="Leave To"
                              ref={toDate}
                              onFocus={() => (toDate.current.type = "date")}
                              onBlur={() => (toDate.current.type = "date")}
                              className="form-control small-box"
                              onChange={(e) => setToDate(e.target.value)}
                            />
                          </td> */}
                          <td>Leave From</td>
<td>
  <input
    type="date"
    ref={fromDate}
    defaultValue={new Date().toISOString().split("T")[0]} // today's date
    className="form-control small-box"
    onChange={(e) => setFromDate(e.target.value)}
  />
</td>
<td>Leave To</td>
<td>
  <input
    type="date"
    ref={toDate}
    defaultValue={new Date().toISOString().split("T")[0]} // today's date
    className="form-control small-box"
    onChange={(e) => setToDate(e.target.value)}
  />
</td>
                          <td>
                            <p className="text-danger">
                              {/* <b> Days {DiffDays ? DiffDays : 0}</b> */}
                              <b> Days {DiffDays > 0 ? DiffDays : 0}</b>
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td>Leave Category</td>
                          <td>
                            <select
                              class="form-select "
                              aria-label="Default select example"
                              onChange={formik.handleChange("Leave_Category")}
                              onBlur={formik.handleBlur("Leave_Category")}
                              value={formik.values.Leave_Category}
                              placeholder="Leave Category"
                            >
                              <option selected="selected">
                                Select Catgeory
                              </option>
                              {LeaveData
                                ? LeaveData?.map((d, i) => (
                                    <>
                                      <option value={d?.leavecateGory}>{d?.leavecateGory}</option>
                                    </>
                                  ))
                                : null}
                            </select>
                          </td>

                          <td>
                            <p className="text-primary">
                              <b>Availiable Days: {availableDaysCount}</b>
                            </p>
                          </td>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr>
                          <td>Leave Reason</td>
                          <td>
                            <input
                              type="text"
                              className="form-control small-box"
                              onChange={formik.handleChange("Notes")}
                              onBlur={formik.handleBlur("Notes")}
                              value={formik.values.Notes}
                            />
                          </td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  {/* <div className="container-fluid">
                    <div className="row">
                      <p className="fs-small text-secondary">
                        Contact Information
                      </p>
                      <div className="row">
                        <div className="col-md-6">
                          <div class="mb-3">
                            <label class="form-label fs-small text-secondary">
                              Address
                            </label>
                            <textarea
                              class="form-control"
                              placeholder="Address Here.."
                              onChange={formik.handleChange("CDL_Address")}
                              onBlur={formik.handleBlur("CDL_Address")}
                              value={formik.values.CDL_Address}
                            ></textarea>
                          </div>
                          <div class="mb-3">
                            <label class="form-label fs-small text-secondary">
                              Street Address
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              onChange={formik.handleChange("CDL_Street")}
                              onBlur={formik.handleBlur("CDL_Street")}
                              value={formik.values.CDL_Street}
                            />
                          </div>
                          <div class="mb-3">
                            <label class="form-label fs-small text-secondary">
                              ZIP/Postel Code
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              onChange={formik.handleChange("CDL_Zip")}
                              onBlur={formik.handleBlur("CDL_Zip")}
                              value={formik.values.CDL_Zip}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div class="mb-3">
                            <label
                              for="exampleInputEmail1"
                              class="form-label fs-small text-secondary"
                            >
                              City
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              onChange={formik.handleChange("CDL_City")}
                              onBlur={formik.handleBlur("CDL_City")}
                              value={formik.values.CDL_City}
                            />
                          </div>

                          <div class="mb-3">
                            <label
                              for="exampleInputEmail1"
                              class="form-label fs-small text-secondary"
                            >
                              Phone Number
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              onChange={formik.handleChange("CDL_Phone")}
                              onBlur={formik.handleBlur("CDL_Phone")}
                              value={formik.values.CDL_Phone}
                            />
                          </div>
                          <div class="mb-3">
                            <label class="form-label fs-small text-secondary">
                              Email
                            </label>
                            <input
                              type="email"
                              className="form-control"
                              onChange={formik.handleChange("CDL_Email")}
                              onBlur={formik.handleBlur("CDL_Email")}
                              value={formik.values.CDL_Email}
                            />
                          </div>
                          <div class="mb-3">
                            <label class="form-label fs-small text-secondary">
                              State
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              onChange={formik.handleChange("CDL_State")}
                              onBlur={formik.handleBlur("CDL_State")}
                              value={formik.values.CDL_State}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> */}
                  <div className="flex justify-center items-center">
                    <button className="bg-gray-700 text-white px-2 py-1 rounded hover:bg-black  flex items-center justify-between font-semibold text-sm">
                      <IoIosAddCircleOutline />
                      &nbsp;Apply
                    </button>
                  </div>
                </div>
              </form>
              <div
                className="current-leavestatus mt-4 scroll h-auto"
                style={{ maxHeight: "250px" }}
              >
                <p className="font-normal text-sm my-4">
                  Leave History of Employee
                </p>
                <table class="table">
                  <tbody>
                    <tr className="">
                      <td>Si No</td>
                      <td>Leave Type</td>
                      <td>From Dt</td>
                      <td>To Dt</td>
                      <td>Appr Dt</td>
                      <td>Leaves</td>
                      <td>Rejoin </td>
                      <td>Status</td>
                      <td>Ticket</td>
                      <td>Approved By</td>
                      <td>Next Expiry Leave</td>
                      <td>Notes</td>
                      <td>Rejoin Comments</td>
                    </tr>
                    {LeaveHistoryData
                      ? LeaveHistoryData?.map((d, i) => (
                          <tr key={i} className="dataTr">
                            <td>{i + 1}</td>
                            <td>{d?.Leave_Type}</td>
                            <td>{dayjs(d?.FROM_DT).format('YYYY-MM-DD')}</td>
                            <td>{dayjs(d?.TO_DATE).format('YYYY-MM-DD')}</td>
                            <td>{dayjs(d?.APRV_DT).format('YYYY-MM-DD')}</td>
                            <td>{d?.LEAVES}</td>
                            <td>{dayjs(d?.Re_joinOn).format('YYYY-MM-DD')}</td>
                            <td>{d?.Status}</td>
                            <td>{d?.Ticket}</td>
                            <td>{d?.APRD_BY}</td>
                            <td>{d?.NEXT_EXP_LEAVE}</td>
                            <td>{d?.NOTES}</td>
                            <td>{d?.REJN_COMMENTS}</td>
                          </tr>
                        ))
                      : null}
                  </tbody>
                </table>
              </div>
              <div
                className="current-leavestatus mt-4 scroll h-auto"
                style={{ maxHeight: "250px" }}
              >
                <p className="font-normal text-sm my-4">
                  Other employees on leave approved on the requested period
                </p>
                <table class="table">
                  <tbody>
                    <tr className="">

                        
    {/* "EmpId": "CBX007",
    "Name": "Ashok  Ramachandran",
    "JobTitle": "Service Officer",
    "Leave_Name": "Annual Leave",
    "ApplicationDate": "2025-07-30T09:34:45.96",
    "Leave_From": "2025-09-01T00:00:00",
    "Leave_To": "2025-10-05T00:00:00",
    "Total_Days": 35,
    "Notes": "Annual leave ",
    "ApprovalStatus": "APPROVED" */}
     <td>Si No</td>
                      <td>EmpID</td>
                      <td>Name</td>
                      <td>Job Title</td>
                      <td>Leave Name</td>
                      <td>Application Date</td>
                      <td>Leave From</td>
                      <td>Leave To</td>
                      <td>Total Days</td>
                      <td>Notes</td>
                      <td>ApprovalStatus</td>
                    </tr>
                    {OtherLeaveHistoryData
                      ? OtherLeaveHistoryData?.map((d, i) => (
                          <tr key={i} className="dataTr">
                            <td>{i + 1}</td>
                            <td>{d?.EmpId}</td>
                            <td>{d?.Name}</td>
                            <td>{d?.JobTitle}</td>
                            <td>{d?.Leave_Name}</td>
                            <td>{dayjs(d?.ApplicationDate).format('YYYY-MM-DD')}</td>
                            <td>{dayjs(d?.Leave_From).format('YYYY-MM-DD')}</td>
                            <td>{dayjs(d?.Leave_To).format('YYYY-MM-DD')}</td>
                            <td>{d?.Total_Days}</td>
                            <td>{d?.Notes}</td>
                            <td>{d?.ApprovalStatus}</td>
                          </tr>
                        ))
                      : null}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeaveApplicationPopup;
